/* eslint-disable react/jsx-no-bind */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import modalTypes from '../../constants/modalTypes';
import ToastrService from '../../services/toastrService';
import * as imageUtils from '../../utils/imageUtils';

const ChatToMeItem = ({comment, actions, artist, user, activeProfile, history}) => { 
    const isOwnProfile = user && user.Profiles.find(p => p.ID === artist.RoleID);

    const isActiveProfile = activeProfile && activeProfile.ID === artist.RoleID;

    const isMyComment = activeProfile && comment.AuthorRoleID === activeProfile.ID;

    const isVisitorComment = comment.AuthorRoleID != artist.RoleID;

    const viewConversation = (event) => {
        event.preventDefault();
        actions.getConversation(artist.Username, comment.AuthorUsername);
        actions.showModal(modalTypes.CONVERSATION);
    };

    const reportSpam = (event) => {
        event.preventDefault();
        if (confirm('Report this comment as spam?')) { 
            history.push(`/ReportSpam?roleID=${activeProfile.ID}&spamType=Comment&id=${comment.ID}&returnUrl=${window.location.pathname}`);
        }
    };

    const deleteComment = (event) => {
        event.preventDefault();
        if(confirm(`Delete comment from ${comment.AuthorName}`)) {
            const toastrService = new ToastrService();
            actions.deleteComment(artist.Username, comment.ID)
                .then(comment => {
                    toastrService.showSuccess('', 'The comment has been deleted!');
                    //reload the comments
                    actions.getComments(artist.Username, true);
                })
                .catch(error => {
                    toastrService.showError('', 'Sorry, something went wrong! Unable to delete comment.');
                });   
            }
    };

    const approveComment = (event) => {
        event.preventDefault();
        const toastrService = new ToastrService();
        actions.approveComment(artist.Username, comment.ID)
            .then(comment => {
                toastrService.showSuccess('', 'The comment has been approved!');
                //reload the comments
                actions.getComments(artist.Username, true);
            })
            .catch(error => {
                toastrService.showError('', 'Sorry, something went wrong! Unable to approve comment.');
            });   
    };

    const getThumbnail = (imageUrl, roleType) => {
        const params = '?width=120&aspectw=1&quality=80&mode=crop';
        return imageUtils.getThumbnail(imageUrl, roleType, params);
    };

    return (
        <li>
            <div className="userthumb">
                <Link to={`/${comment.AuthorUsername}`}>
                    <img src={getThumbnail(comment.Thumbnail, comment.AuthorRoleType)} alt={comment.AuthorName} />
                </Link>
            </div>
            <p className="length">{new Date(comment.Date).toLocaleDateString('en-GB', { year: 'numeric', month: 'short', day: 'numeric' })}</p>
            <h2>
                <Link to={`/${comment.AuthorUsername}`} className="transition link">{comment.AuthorName}</Link>
            </h2>
            <div className="message">
                <p>{comment.Comment}</p>
            </div>
            
            {isActiveProfile || isOwnProfile ?
                <div className="messagectrl">
                    {comment.Approved ?   
                        <div>                           
                            <p>Status:&nbsp;<span>Approved</span></p>
                            {
                                isActiveProfile ?
                                    <div className="messagebtns">
                                        {!isMyComment ?
                                            <React.Fragment>
                                                <a href="#" className="approvereject btn-small transition" onClick={viewConversation}>Reply</a>
                                                <a href="#" className="approvereject btn-small transition" onClick={reportSpam}>Report spam</a>
                                            </React.Fragment>
                                            : null
                                        }
                                        <a href="#" className="approvereject btn-small transition" onClick={deleteComment}>Delete</a>
                                    </div>
                                    : null
                            }
                            
                        </div>
                    :
                        <div>
                            <p>Status:&nbsp;<span>Pending Approval</span></p>
                            {
                                isActiveProfile ?
                                    <div className="messagebtns">
                                        <a href="#" className="approvereject btn-small transition" onClick={approveComment}>Approve</a>
                                        {!isMyComment ?
                                            <a href="#" className="approvereject btn-small transition" onClick={reportSpam}>Report spam</a>
                                            : null
                                        }
                                        <a href="#" className="approvereject btn-small transition" onClick={deleteComment}>Delete</a>
                                    </div>
                                : null
                            }
                        </div>
                    }                
                    </div>
                : null
            }

            {isVisitorComment?            
                <div className="messagefoot"><a href="#" onClick={viewConversation} className="transition no-ajaxy btn-viewconversation">View Conversation</a></div>
            :null}
        </li>
    );
};

ChatToMeItem.propTypes = {
    comment: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    artist: PropTypes.object.isRequired,
    user: PropTypes.object,
    activeProfile: PropTypes.object,
    history: PropTypes.object.isRequired
};

export default withRouter(ChatToMeItem);